const DELIVERY_TYPES = {
  fr: [
    {
      label: 'Case postale',
      value: 'postalbox',
    },
    {
      label: 'Route rurale',
      value: 'rural',
    },
    {
      label: 'Aucun',
      value: 'none',
    },
  ],
  en: [
    {
      label: 'P.O. Box',
      value: 'postalbox',
    },
    {
      label: 'Rural route',
      value: 'rural',
    },
    {
      label: 'None',
      value: 'none',
    },
  ],
};

export default DELIVERY_TYPES;
